import { useModelService } from "@shared/services/api/hooks/useModelService";
import UserBasedTempFileRepository from "../repositories/UserBasedTempFileRepository";

const useUserBasedTempFileService = () => {
  const repository = new UserBasedTempFileRepository();

  const { useCreate } = useModelService(repository);

  return {
    useCreate,
  };
};

export default useUserBasedTempFileService;
